import { isOnline, sessionGet } from '@et/utils';
import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ProfileState } from '../state/profile.state';

@Injectable({
  providedIn: 'root',
})
export class OfflineGuard {
  private router = inject(Router);
  private store = inject(Store);

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const online = isOnline();
    const profileId = this.store.selectSnapshot(ProfileState.v2ProfileId);
    const hasSession = sessionGet('lastCheckedPin');
    if (profileId && online === false && !hasSession) {
      this.router.navigateByUrl('/pincode');
    }
    return true;
  }
}
